<script lang="ts">
    interface Props {
        fill: string;
    }

    let { fill }: Props = $props();
</script>

<svg
    version="1.1"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    xml:space="preserve"
>
    <g><circle cx="16" cy="16" r="6" /></g>
</svg>
